import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u4qayfrgch: FaireBrandEntity = {
  token: "b_u4qayfrgch",
  type: "brand",
  name: "Drop Supplements",
  avatarUrl:
    "https://cdn.faire.com/fastly/8b02e122cc3cba66120b0b0b9139b750f1343fb2f2cb60d74d5441cbe95b1596.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f00906d6cc8aeeb08a3ea419c7ab5c3b20f13b9c2261183abb8f2674e1512a4f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8b02e122cc3cba66120b0b0b9139b750f1343fb2f2cb60d74d5441cbe95b1596.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f00906d6cc8aeeb08a3ea419c7ab5c3b20f13b9c2261183abb8f2674e1512a4f.jpeg",
  location: "Tallahassee, FL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "In today's fast-paced world, maintaining wellness can feel overwhelming. At Drop, we believe that health should be accessible, uncomplicated, and tailored to fit seamlessly into your daily life.\n\nWe recognized that traditional supplements often come with barriers like bulky pills, complex regimens, and inconsistent results. That’s why we designed Drop to work with your life, not against it. Our liquid vitamins are simple, clean, and effective. They absorb fast, taste good, and help you stay consistent without overthinking it.\n\nDrop was created for real people with real lives. Our mission is to empower you to take control of your health journey. With Drop, you're not just taking a supplement; you're embracing a lifestyle that prioritizes simplicity, consistency, and well-being.\n\nWhen wellness fits effortlessly into your routine, it's easier to stay on track and feel your best every day.\n\nEvery Drop formula is made with clean, traceable ingredients. No fillers, no artificial colors, no added sugars, and nothing you don’t need. Just high-quality nutrients that your body recognizes and can absorb quickly.\n\nAll of our products are vegan-friendly, gluten-free, non-GMO, and made without yeast or artificial preservatives. We test every batch for purity and potency, so you can feel confident knowing exactly what’s inside each drop.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:33.406Z",
    importedBy: "entity-db-cli",
  },
};
